import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

/*
This function will merge the two category trees and set the `isLive` property
 */
const mergeCategoryTrees = (allCategories, liveCategories) => {
  const liveMap = new Map();

  // Create a map of live categories for quick lookup
  const buildLiveMap = (categories) => {
    categories.forEach((category) => {
      liveMap.set(category.categoryID, category);
      if (category.children && category.children.length > 0) {
        buildLiveMap(category.children);
      }
    });
  };

  buildLiveMap(liveCategories);

  // Recursively process categories
  const processCategories = (categories) =>
    categories.map((category) => {
      const isLive = liveMap.has(category.categoryID);
      return {
        ...category,
        isLive,
        children: category.children ? processCategories(category.children) : [],
      };
    });

  return processCategories(allCategories);
};

const fetchCategoryTree = async (module, payload = { opts: {} }) => {
  const api = useApiStore();
  const { getters, commit, rootState, dispatch } = module;
  const config = Object.assign(
    getDefaultOpts(),
    {
      isCms: false,
      isAuth: false,
    },
    payload.opts
  );
  if (!getters.categoryTree().length || rootState.showCMS) {
    /*
    First, we get the "live only" category tree
     */
    const res1 = await dispatch("httpRequest", {
      func: api.fetchCategoryTree(false),
      config,
    });
    const liveItems = res1.data;
    let allItems = [];
    /*
    If the user is logged in we also need to get the full category tree.
     */
    if (rootState.showCMS) {
      const res2 = await dispatch("httpRequest", {
        func: api.fetchCategoryTree(true),
        config,
      });
      allItems = res2.data;
    }
    /*
    We then merge the two trees and set the `isLive` property
     */
    const items = allItems.length
      ? mergeCategoryTrees(allItems, liveItems)
      : liveItems.map((item) => ({ ...item, isLive: true }));
    commit("storeCategoryTree", items);
  }
  return getters.categoryTree();
};

export { fetchCategoryTree };
